export default __webpack_public_path__ + "static/media/music.2918dbea.svg";